import { Component, Type, Input, inject } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faEnvelope, faUser, faCog, faLevelUp, faEye, faPencilSquare, faPowerOff, faL, faHeart } from '@fortawesome/free-solid-svg-icons';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { HostListener } from '@angular/core';
import { RouterLinkActive } from '@angular/router';
import { LoginPopupComponent } from '../login-popup/login-popup.component';
import { UserDetailsService } from '../services/user-details.service';
import { ActivatedRoute } from '@angular/router';
import { ApiServicesService } from '../services/api-services.service';
import { ServicesService } from '../my-profile/services.service';
// import { SocketService } from '../services/socket.service';
// import { isPlatformBrowser } from '@angular/common';
import { OnInit, OnDestroy } from '@angular/core';
import { SocketService } from '../services/socket.service';
import { Subject, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { SnackbarService } from '../services/snackbar.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [FontAwesomeModule, CommonModule, RouterLink, RouterLinkActive, LoginPopupComponent],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})

export class HeaderComponent {

  private headerUpdateSubscription!: Subscription;
  private routerSubscription!: Subscription;



  faEnvelope = faEnvelope;
  faUsers = faUser;
  facog = faCog;
  faleval = faLevelUp;
  faeye = faEye;
  fapen = faPencilSquare;
  fapower = faPowerOff;
  faheart = faHeart;
  @Input() isuser: boolean = false;
  is_show_menu: boolean = false;
  login_popup: boolean = false;
  isScrolled = false;
  private taskservices = inject(ServicesService);
  isWidth = false;
  profile_img = '';
  userData: any;
  showLogin: boolean = false;
  name: any;
  isuser_login: boolean = false;
  total_msg: any = null;
  total_friends: any = null;


  unreadMessageCount: number = 0;
  private subscription!: Subscription;
  private subscription2!: Subscription;
  previousUrl!: any;
  private destroy$ = new Subject<void>();
  total_friendsAv: any;
  total_msgAv: any;
  lastSlug!: any;
  lastSlugPart: any;
  private routerEventsSubscription!: Subscription;
  secondLastSlugPart!: string;

  constructor(private userdetails: UserDetailsService,private activatedRoute: ActivatedRoute,
    private router: Router, private route: ActivatedRoute, public api: ApiServicesService, private socketService: SocketService, private snackbarService: SnackbarService) {
  }

  ngOnInit() {
    if (window && typeof window !== 'undefined' && window.localStorage) {
      const userdata = localStorage.getItem('encryptedUserData');
      if (userdata != null && userdata != undefined && userdata != '') {
        this.isuser = true;
        this.isuser_login = true;
      } else {
        this.isuser_login = true;
        this.login_popup = true;
      }
    }
    this.headerUpdateSubscription = this.userdetails.headerUpdate$.subscribe(() => {
      this.user_logout();
    });

    this.route.queryParams.subscribe(params => {
      this.login_popup = false;
      this.showLogin = params['showlogin'];
      if (this.showLogin && !this.isuser) {
        this.login_popup = true;
      }
    });


    const encryptedData = localStorage.getItem('encryptedUserData');
    if (encryptedData) {
      const decryptedData = this.api.decryptData(encryptedData);
      if (decryptedData && decryptedData.user) {
        this.userData = decryptedData;
        const userName = this.userData.username;
        this.profile_img=this.userData.thumbnail_image;
        console.log('this.userData',this.userData)
       
        this.getCount();
      }
    } else {
      
    }

  
    this.userdetails.userdetails$.subscribe((userData) => {
      if (userData && userData.user) {
        const is_myProfile = this.api.checkProfile(userData.user.username);
        if (is_myProfile) {
          this.userData = userData;
          this.profile_img = this.userData.thumbnail_image;
          this.name = this.userData.user.username;
          this.total_friends = this.total_friends ? this.total_friends : userData.totalPendingFriendRequests
          this.total_msg = this.total_msg ? this.total_msg : userData.totalUnreadMessages;
          this.userdetails.setMessageCount(this.total_msg);
          this.userdetails.setFriendsCount(this.total_friends);
          if (!this.socketService.isConnected) {
            this.socketService.connect(this.userData.user.token);
            this.setupSocketListeners();
          }
       
        }
      }
    });



    this.routerEventsSubscription = this.router.events
    .pipe(filter(event => event instanceof NavigationEnd)) // Filter for navigation end events
    .subscribe(() => {
      const currentUrl = this.router.url; // Full URL
      const urlParts = currentUrl.split('/').filter(part => part); // Filter removes empty strings
      // Last part
      this.secondLastSlugPart = urlParts[urlParts.length - 3] || ''; // Second-to-last part
      if(this.secondLastSlugPart=='my-profile'){
        this.lastSlugPart = urlParts[urlParts.length - 1] || ''; 
      }else{
        this.lastSlugPart='';
      }

    });



    // this.router.events
    //       .pipe(
    //         takeUntil(this.destroy$),
    //         filter((event) => event instanceof NavigationEnd)
    //       )
    //       .subscribe((event: NavigationEnd) => {
    //         if (event.url.includes('my-profile')) {
    //           const currentUrl = event.urlAfterRedirects;
    //           const currentUrlSplit = currentUrl?.split("/") || [];
    //           const previousUrlSplit = this.previousUrl?.split("/") || [];
    //           if (
    //             currentUrlSplit.length > 2 &&
    //             previousUrlSplit.length > 2 &&
    //             currentUrlSplit[2] !== previousUrlSplit[2]
    //           ) {

    //           } else if (previousUrlSplit.length == 1) {

    //           }
    //           this.previousUrl = currentUrl;
    //         }
    //       });







  }


  // ngAfterViewInit(): void {
  //   const encryptedData = localStorage.getItem('encryptedUserData');
  //   if (encryptedData) {
  //     const decryptedData = this.api.decryptData(encryptedData);
  //     if (decryptedData && decryptedData.user) {
  //       this.total_friends = this.userData.totalPendingFriendRequests
  //       this.total_msg = this.userData.totalUnreadMessages;
  //       this.userdetails.setMessageCount(this.total_msg);
  //       this.userdetails.setFriendsCount(this.total_friends);
  //     }
  //   }
  // }


  ngOnDestroy() {
    if (this.headerUpdateSubscription) {
      this.headerUpdateSubscription.unsubscribe();
    }

    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }

  }


  private setupSocketListeners(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    if (this.subscription2) {
      this.subscription2.unsubscribe();
    }

    this.subscription = this.socketService.on('unreadCount').subscribe((count: number) => {
      this.total_msg = count;
      this.userdetails.setMessageCount(this.total_msg);
    });



    this.subscription2 = this.socketService.on('pendingFriendRequestCount').subscribe((friendRequest: number) => {
      this.total_friends = friendRequest;
      this.userdetails.setFriendsCount(this.total_friends);
    });


  }

  show_menu() {
    this.is_show_menu = !this.is_show_menu;
  }


  getCount(){
    this.api.getCounts().subscribe({
      next: (response) => {
        this.total_friends=response.pendingFriendRequests,
        this.total_msg=response.unreadMessages

      },
      error: (error) => { }
    })
  }


  user_logout() {
    // console.log('consol................')

    this.api.logout().subscribe({
      next: (response) => {
        this.snackbarService.openCustomSnackbar(
          {
            icon: true,
            // message: response.message,
            message: 'Logout Successfully',
            className: 'success',
          }
        );

      },
      error: (error) => { 
        this.snackbarService.openCustomSnackbar(
          {
            icon: true,
        message: "Logout",
        className: 'success',
      }
    );
      }
    })

    this.isuser = false;
    this.router.navigate(['']);
    localStorage.removeItem("encryptedUserData");
    localStorage.removeItem("dropdownData");
    localStorage.removeItem("AdvancedropdownData");
    localStorage.removeItem("quickdropdownData");
    localStorage.removeItem("formData");
    localStorage.removeItem("filterDropdowndata");
    this.api.removeheaders();
    this.socketService.disconnect();
    this.login_popup = true;

  }

  user_login_popup() {
    this.login_popup = true;
  }

  close_menu() {
    this.is_show_menu = false;
  }

  handleUserLogin(value: boolean) {
    this.login_popup = value;
  }

  setuserval(value: boolean) {
    this.isuser = value;
  }


  navigate() {
    if (window.innerWidth >= 1024) {
      this.router.navigate(['/my-profile', this.userData?.user?.username, 'Profile'])
    }
  }
  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled = window.scrollY >= 100;
    this.isWidth = window.scrollY >= 50;
  }


  viewed_tab(view: any) {
    this.taskservices.close_task(view);
    this.taskservices.changefriTab(1);
    this.router.navigate(["/my-profile", this.name, view]);
  }

  // -------socket msg count--------



}
